(function($){
/*===========================
    Intiolize Plugins
=============================*/

/*===========================
    Theme Functions
=============================*/
function theme_script(){

}
//============================
$(document).ready(function () {
   theme_script();
$(window).resize(function () {
  theme_script();
  });
});
/*===========================
    Extra Function
=============================*/
// $(function () {
//     $('.site-input').focus(function () {
//         $(this).data('placeholder', $(this).attr('placeholder'))
//                .attr('placeholder', '');
//     }).blur(function () {
//         $(this).attr('placeholder', $(this).data('placeholder'));
//     });
// });

/*===========================
    Theme Page Loader
=============================*/
//  $(window).on('load', function () {
//     $('#status').fadeOut();
//     $('#preloader').delay(100).fadeOut('slow');
// });   
/*===========================
    Scroll Animation
=============================*/
window.sr = ScrollReveal();
 sr.reveal('.footop', { 
  duration: 1000,
  origin: 'top',
  distance: '100px',
  useDelay: 'onload'
});
 sr.reveal('.fooright', { 
  duration: 1000,
  origin: 'right',
  distance: '50px',
  useDelay: 'onload'
});
  sr.reveal('.fooleft', { 
  duration: 1000,
  origin: 'left',
  distance: '50px',
  useDelay: 'onload'
});
sr.reveal('.foobottom', { 
  duration: 1000,
  origin: 'bottom',
  distance: '100px',
  useDelay: 'onload'
});
})(jQuery);
